export default {
  moduleName: 'Business',
  dataForm: {
    'department_id': undefined, // required, ref: department - Phòng ban
    'employee_id': undefined, // required, ref: mushroom_user - Mã nhân viên
    'deadline': undefined, // optional - Ngày kết thúc
    'expected_revenue': undefined, // optional - Doanh thu dự kiến
  },
  tableRules: {
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    // showFormSearch: false,
    showUrl: true,
    lengthMenu: [10, 20, 50, 100],
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: '-created_at',
    defaultSort: ['', ''],
    filters: '',
    recordSelected: [],
    dataSearch: {
      value: {},
      valid: {},
      operator: {},
    },
  },
  tableRuleRevenuByDays: {
    lengthMenu: [10, 20, 50, 100],
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: '-revenue_date',
  },
}
